import React, { useEffect, useState } from 'react'
import { Card, Typography, Space, Statistic, InputNumber, Button, message } from 'antd'
import { useAuth } from '../../contexts/AuthContext'
import { notaanota } from '../../services/notaanota'

const { Title, Text } = Typography

const OrgSequence = () => {
  const [loading, setLoading] = useState(false)
  const [seq, setSeq] = useState({ organizationId: null, lastSeq: 0, nr1: '00000000', lastNr2: '00000000' })
  const [newNr1, setNewNr1] = useState(0)
  const { user } = useAuth()

  const load = async () => {
    setLoading(true)
    try {
      const data = await notaanota.getSequence()
      setSeq(data)
      setNewNr1(Number(data?.lastSeq || 0))
    } catch (e) {
      message.error(e?.message || 'Falha ao carregar sequência')
    } finally {
      setLoading(false)
    }
  }

  const save = async () => {
    if (newNr1 < 0 || newNr1 > 99999999) {
      return message.warning('nr1 deve estar entre 0 e 99.999.999')
    }
    const lastNr2Num = (() => {
      try {
        const s = String(seq?.lastNr2 ?? '0')
        const n = parseInt(s.replace(/\D/g, '') || '0', 10)
        return Number.isNaN(n) ? 0 : n
      } catch { return 0 }
    })()
    if (newNr1 < lastNr2Num) {
      return message.warning('nr1 não pode ser menor que a última nr2 usada')
    }
    setLoading(true)
    try {
      const data = await notaanota.setSequence(Math.floor(newNr1))
      //setSeq(data)
      setNewNr1(Number(data?.lastSeq || 0))
      message.success('Sequência atualizada')
      load();
    } catch (e) {
      message.error(e?.message || 'Falha ao salvar sequência')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [])

  return (
    <Card loading={loading} title={<Title level={4}>Sequência de nr1 por Organização</Title>}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Space size="large">
          <Statistic title="nr1 (8 dígitos)" value={seq.nr1} />
          <Statistic title="lastSeq (numérico)" value={seq.lastSeq} />
          <Statistic title="última nr2 usada" value={String(seq.lastNr2 || '0').padStart(8, '0')} />
        </Space>
        <Space size="middle" align="center">
          <Text>Ajustar nr1:</Text>
          <InputNumber min={0} max={99999999} value={newNr1} onChange={(v) => setNewNr1(Number(v || 0))} />
          <Button type="primary" onClick={save} disabled={loading}>Salvar</Button>
          <Button onClick={load} disabled={loading}>Recarregar</Button>
        </Space>
        <Text type="secondary">Organização: {user?.organization?.name || 'desconhecida'}</Text>
      </Space>
    </Card>
  )
}

export default OrgSequence